
import {Options, Vue} from 'vue-class-component';

@Options({
    name: 'Customer',
})
export default class Customer extends Vue {}
